import { WrapperResponsiveComponentProps } from '@/types/props/components';
import clsx from 'clsx';
const WrapperResponsiveComponent: React.FC<WrapperResponsiveComponentProps> = ({
  children,
  desktop,
}: WrapperResponsiveComponentProps) => {
  const containerClassName = clsx('!tw-contents', {
    'max-nine:!tw-hidden': desktop,
    'nine:!tw-hidden': !desktop,
  });

  return <div className={containerClassName}>{children}</div>;
};

export default WrapperResponsiveComponent;
